import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Spinner from '@blockcatio/tabby-library/lib/components/Spinner';
import FormattedWei from '@blockcatio/tabby-library/lib/components/FormattedWei';
import { PropTypeBn } from '@blockcatio/tabby-library/lib/utilities/PropTypeBn';

import WalletInfo from '../../components/WalletInfo';
import CurrencySelectorContainer from '../../components/CurrencySelector';
import CampaignDetailsTable from '../../components/CampaignDetailsTable';
import PropTypeCampaign from '../../utilities/propTypes/PropTypeCampaign';

const Payment = ({
  campaignDetails,
  paymentFeeEth,
  paymentFeeCat,
  fiatPaymentFeeEth,
  fiatPaymentFeeCat,
  onClick,
  isSending,
  isLoading,
  address,
  balance,
  catBalance,
}) => {
  const handlePaymentButtonClick = ({ target: { value } }) => {
    onClick(value);
  };

  return (
    <div className="campaign-payment">
      <h1>Confirm Payment</h1>
      {!isLoading && <WalletInfo address={address} balance={balance} catBalance={catBalance} />}
      <CampaignDetailsTable {...campaignDetails} />
      {paymentFeeCat &&
        paymentFeeEth && (
          <React.Fragment>
            <div className="actions">
              <h3>Select Payment Method</h3>
              <CurrencySelectorContainer />
              <div className="payment-type ETH">
                <strong>Pay with ETH</strong>
                <FormattedWei wei={paymentFeeEth} />
                <em>{fiatPaymentFeeEth}</em>
                <button
                  className="btn"
                  type="submit"
                  value="ETH"
                  name="submit"
                  onClick={handlePaymentButtonClick}
                >
                  Pay
                </button>
              </div>
              <div className="payment-type CAT">
                <strong>Pay with CAT</strong>
                <FormattedWei wei={paymentFeeCat} suffix="CAT" />
                <em>{fiatPaymentFeeCat}</em>
                <button
                  className="btn"
                  type="submit"
                  value="CAT"
                  name="submit"
                  onClick={handlePaymentButtonClick}
                >
                  Pay
                </button>
              </div>
            </div>
            <Spinner loading={isSending} />
          </React.Fragment>
        )}
    </div>
  );
};

Payment.displayName = 'Payment';

Payment.defaultProps = {
  onClick: noop,
  paymentFeeEth: null,
  paymentFeeCat: null,
  fiatPaymentFeeEth: '',
  fiatPaymentFeeCat: '',
  isSending: false,
  isLoading: false,
  address: '',
  balance: null,
  catBalance: null,
};

Payment.propTypes = {
  campaignDetails: PropTypes.shape(PropTypeCampaign).isRequired,
  onClick: PropTypes.func,
  paymentFeeEth: PropTypeBn,
  paymentFeeCat: PropTypeBn,
  fiatPaymentFeeEth: PropTypes.string,
  fiatPaymentFeeCat: PropTypes.string,
  isSending: PropTypes.bool,
  isLoading: PropTypes.bool,
  address: PropTypes.string,
  balance: PropTypeBn,
  catBalance: PropTypeBn,
};

export default Payment;



// WEBPACK FOOTER //
// ./src/containers/createCampaign/Payment.js